module.exports = __webpack_public_path__ + "img/icon-forex-big.3a09465d.svg";